module.exports = __webpack_public_path__ + "img/transferLog.9ffbd2eb.svg";